import { DragEndEvent } from '@dnd-kit/core';

export interface DropResult {
  source: {
    index: number;
    droppableId: string;
  };
  destination: {
    index: number;
    droppableId: string;
  } | null;
  draggableId: string;
}

export const notValidDrop = (result: DropResult): boolean => {
  return (
    result?.destination?.index === result?.source?.index ||
    !result?.destination?.hasOwnProperty('index') ||
    result?.destination?.hasOwnProperty('source')
  );
};

// Helper to convert DragEndEvent to DropResult format for backward compatibility
export const convertDragEndToDropResult = (event: DragEndEvent): DropResult | null => {
  const { active, over } = event;

  if (!over) {
    return null;
  }

  // Get container IDs - check if it's a sortable item or a droppable container
  const sourceContainer = active.data.current?.sortable?.containerId || 'ProcessSidebar';
  let destContainer: string;
  let destIndex: number;

  // Check if we're dropping over a sortable item or a container
  if (over.data.current?.sortable) {
    destContainer = over.data.current.sortable.containerId || 'ProcessSidebar';
    // Use the index from the sorted items array, which @dnd-kit calculates automatically
    // This is the position where the item should be inserted
    destIndex = over.data.current.sortable.index ?? 0;
  } else {
    // Dropping over a container directly (not over an item)
    destContainer = over.id as string;
    destIndex = 0; // Default to first position when dropping into empty container
  }

  const sourceIndex = active.data.current?.sortable?.index ?? 0;

  return {
    draggableId: active.id as string,
    source: {
      index: sourceIndex,
      droppableId: sourceContainer as string,
    },
    destination: {
      index: destIndex,
      droppableId: destContainer as string,
    },
  };
};
